export default __webpack_public_path__ + "b06dd2f1cbd0ec7263bd0e55559c7ed2.jpg";